import React, { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Sentiment, SENTIMENT_EMOJI } from "@models/sentiment";

export interface SentimentLabelProps {
  sentiment?: Sentiment;
  emptyLabel?: string;
}

const SentimentLabel: FC<SentimentLabelProps> = ({
  sentiment,
  emptyLabel,
}) => {
  const { t } = useTranslation();

  if (!sentiment) {
    return (
      <Typography component="span" color="text.secondary">
        {emptyLabel ?? t("sessions.noSentiment")}
      </Typography>
    );
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.75} component="span">
      <Typography component="span" aria-hidden="true" sx={{ fontSize: 18, lineHeight: 1 }}>
        {SENTIMENT_EMOJI[sentiment]}
      </Typography>
      <Typography component="span">{t(`sentiment.values.${sentiment}`)}</Typography>
    </Stack>
  );
};

export default SentimentLabel;
